import axios from 'axios';
export const baseUrl = "https://api.benice.ir/";
axios.defaults.baseURL = baseUrl;

//set header for basic auth
const username = 'bashgah';
const password = 'QQkxnAqOre6QpmMzafIE2wdkMA8qfy0389bK2oeekx6eIDjI3lLa3GmdfffhH1ODIyuDJgdFB4n';
let authHeader = {
    'Authorization': 'Basic ' + btoa(username + ':' + password)
}



export const GetCustomerInfo = async (mobile) => {
    try {
        return await axios.get(baseUrl + `CustomerInfo?Mobile=${mobile}`, {
            headers:
                authHeader
        })
    } catch (error) {
        alert('خطا در برقراری ارتباط')
    }

};
export const GetOrders = async (params) => {
    console.log(params)
    try {
        return await axios.get(baseUrl + `CustomerOrders?CustomerId=${params.CustomerId}&FromDate=${params.FromDate}&ToDate=${params.ToDate}&Kala=${params.Kala}&Store=${params.Store}`, {
            headers:
                authHeader
        })
    } catch (error) {
        alert('خطا در برقراری ارتباط')
    }

};
export const CustomerShekayat = async (params) => {
    try {
        return await axios.get(baseUrl + `CustomerShekayat?Mobile=${params.mobile}&FromDate=${params.fromDate}&ToDate=${params.toDate}`, {
            headers:
                authHeader
        })
    } catch (error) {
        alert('خطا در برقراری ارتباط')
    }

};
export const GetTypeShekayat = async (params) => {
    try {
        return await axios.get(baseUrl + `TypeShekayat`, {
            headers:
                authHeader
        })
    } catch (error) {
        alert('خطا در برقراری ارتباط')
    }

};
export const CheckMobile = async (params) => {
    try {
        return await axios.get(baseUrl + `CheckMobile?Mobile=${params}`, {
            headers:
                authHeader
        })
    } catch (error) {
        alert('خطا در برقراری ارتباط')
    }

};
export const customerFactor = async (params) => {
    try {
        return await axios.get(baseUrl + `CustomerFactor?CustomerId=${params.customerId}&OrderID=${params.orderId}`, {
            headers:
                authHeader
        })
    } catch (error) {
        alert('خطا در برقراری ارتباط')
    }

};
export const UpdateCustomer = async (params) => {
    try {
        return await axios.post(baseUrl + 'UpdateCustomer', params, {
            headers:
                authHeader
        })
    } catch (error) {
        alert('خطا در برقراری ارتباط')
    }

};
export const ChangePass = async (params) => {
    try {
        return await axios.post(baseUrl + 'ChangePass', params, {
            headers:
                authHeader
        })
    } catch (error) {
        alert('خطا در برقراری ارتباط')
    }

};
export const SabtShekayat = async (params) => {
    try {
        return await axios.post(baseUrl + 'SabtShekayat', params, {
            headers:
                authHeader
        })
    } catch (error) {
        alert('خطا در برقراری ارتباط')
    }

};
export const sendCodeApi = async (params) => {
    try {
        return await axios.get(baseUrl + `SendCode?Mobile=${params}`, {
            headers:
                authHeader
        })
    } catch (error) {
        alert('خطا در برقراری ارتباط')
    }

};
export const loginApi = async (params) => {
    try {
        return await axios.post(baseUrl + `Login?Mobile=${params.mobile}&Pass=${params.password}&IIP=${params.ip}`, {}, {
            headers:
                authHeader
        })
    } catch (error) {
        alert('خطا در برقراری ارتباط')
    }

};
